import FullScreenCard from '../../shared/FullScreenCard';
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useEffect, useState } from 'react';
import { fetchGet } from '../../../utils/fetch';
import Table from '../../shared/Table';

function RequestHistoryUsers() {

  const {
    changeCurrentMenu,
    setUserHistoryId
  } = useContext(GeneralContext);

  const [headers, setHeaders] = useState([
      {id: 'header0', text: 'Alerta'}
  ]);

  const [activeUsersList, setActiveUsersList] = useState([
      {id: '1a', fields: [
          {id: '0', text: 'Error conectándose al servidor'}
        ]
      }
  ]);

  const [tableType, setTableType] = useState('display');

  const prepareUserList = (list) => {
    setHeaders([
        {id: 'header0', text: 'Nombre'},
        {id: 'header1', text: 'Documento'}
    ]);
    const newList = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].status === 'active') {
        const item = {
          id: list[i].id,
          fields: [
            {id: '0', text: list[i].last_name + ' ' + list[i].first_name},
            {id: '1', text: list[i].document}
          ]
        }
        newList.push(item);
      }
    }
    setActiveUsersList(newList);
    setTableType('actions');
  }

  useEffect(() => {
    const getUsersList = async () => {
        const response = await fetchGet('');
        if (response.success) {
            prepareUserList(response.list);
        }
    }
    getUsersList();
  }, []);

  const navigateToUserHistory = (id) => {
    setUserHistoryId(id);
    changeCurrentMenu('user-history-requests');
  }

  const activeUserActions = [{
    id: 0,
    text: 'Ver',
    buttonFunction: navigateToUserHistory
  }]

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-requests'}>
        <h1>Historial de Solicitudes por Usuario</h1>
        <Table
            headers={headers}
            data={activeUsersList}
            type={tableType}
            actions={activeUserActions}
        />
    </FullScreenCard>
  )
}

export default RequestHistoryUsers